module.exports = __webpack_public_path__ + "static/img/ic_serviceflow_d.c81580f6.png";